import {
    AppIntegrationsRepository,
    MeRepository,
    LicensesRepository,
    AppInstancesRepository,
} from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

const currentDeviceOS = window.deviceOs;

const _directiveDependencies = [];
const _controllerDependencies = ['DeploymentUrlsRestService', '$stateParams', '$window', '$location',
    '$timeout', '$state', '$scope', 'Util', '$rootScope'];

class PcDeploymentWizardController {

    constructor(
        DeploymentUrlsRestService, $stateParams, $window,
        $location, $timeout, $state, $scope, Util,
        $rootScope,
    ) {

        this.$window = $window;
        this.$location = $location;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        this.user = MeRepository.getMyUser();
        this.isMyEmailConfirmed = this.user.attributes.optin !== 'single';
        this.Util = Util;
        this.LicensesRepository = LicensesRepository;
        this.$rootScope = $rootScope;
        this.deployCheck = {
            isEmailValid: false,
            showEmailError: false,
        };

        $scope.imgPath = CWCONFIG.imgPath;

        this.app = AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        this.osType = Util.deepFind(this.app, 'attributes.custom.manifest.compatibleWithServer') ? 'server' : 'desktop';

        this.license = this.getLicense();
        this.licenseId = this.Util.deepFind(this.license, 'id') || '';
        this.$scope.isStep2Finished = false;
        this.$scope.isStep3Finished = false;
        this.$scope.app = this.app;

        this.$timeout(() => {

            this.$rootScope.showDownloadTooltip = false;

        }, 0);

        if (this.$scope.inputData && !this.$scope.inputData.emails) {

            this.$scope.inputData = angular.extend(
                this.$scope.inputData,
                { emails: [this.user.attributes.email] },
            );

        }


        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();

        }

        this.deployChoose = {
            option: 'download',
            isForMe: !!this.user.id,
            showDownloadTooltip: false,
            waitingResponse: false,
        };

        // check if we're on a mobile device
        if (currentDeviceOS === 'android' || currentDeviceOS === 'ios') {

            const isDesktopProduct = ['windows', 'osx'].indexOf(this.$scope.inputData.os) !== -1;
            // and trying to install a desktop product, which hides the download button
            if (isDesktopProduct) {

                this.isFromMobile = true;
                this.deployChoose.option = 'email';

            }

        }
        let timeTooltip;
        // open download tooltip when receive 'download-tooltip:show' event
        eventManager.subscribe('download-tooltip:show', () => {

            this.$rootScope.showDownloadTooltip = true;
            timeTooltip = this.$timeout(() => {

                this.$rootScope.showDownloadTooltip = false;

            }, CWCONFIG.timeouts.notification);

        });

        // close download tooltip when user close modal
        eventManager.subscribe('modal:close', () => {

            this.$timeout(() => {

                this.$rootScope.showDownloadTooltip = false;

            }, 0);
            this.$timeout.cancel(timeTooltip);

        });

        // click handler for link to redeploy on current device
        // timeout hack is used to make sure the dom has been loaded
        this.$timeout(() => {

            const deployViaDownloadElement = angular.element(document.querySelector('#deployActionDownload'));
            deployViaDownloadElement.on('click', () => this.deployViaDownload());

        }, 0);

        this.autoInstall = this.$scope.inputData.autoInstall;
        this.initialautoInstallValue = this.$scope.inputData.autoInstall;
        // if we can automatically install the product initiate deploy sequence
        if (this.autoInstall) {

            this.deployViaDownload();

        }

        const queryParams = this.$location.search();

        // if we get back to the deployment wizard a second time
        // when we deploy on another device, we disable auto install
        this.$scope.inputData = angular.extend(this.$scope.inputData, queryParams, {
            autoInstall: false,
        });

        this.deviceNavigator = Util.getDeviceNavigator();

        // if user move mouse outside of browser we will mark that run program step is started
        this.addEvent(document, 'mouseout', (e) => {

            e = e || window.event;
            const from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName === 'HTML') {

                this.$timeout(() => {

                    this.$scope.isStep2Finished = true;

                }, 3000);

            }

        });
        // when the app instance repo is updated it means user have succesful install the app,
        // then checkmark the install step
        const appInstancesObservable = AppInstancesRepository.getObservable();
        const appInstancesSubscriber = appInstancesObservable
            .subscribe(
                data => this.appInstancesNext(data),
                () => { },
                () => { },
            );

        $scope.$on('$destroy', () => {

            appInstancesSubscriber.dispose();

            // this.$rootScope.showPendingInstallCard = true;
            this.$rootScope.pendingInstallCardOs = this.$scope.inputData.os;

        });
        this.triggerInstall = false;

    }

    getPageName() {

        let pageName = '';

        if (this.$state.current.name.indexOf('.home') > -1) {

            pageName = 'Homepage';

        } else if (this.$state.current.name.indexOf('.devices') > -1) {

            pageName = 'Devices';

        } else if (this.$state.current.name.indexOf('.products') > -1) {

            pageName = 'Products';

        } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

            pageName = 'Subscriptions';

        }

        return pageName;

    }

    appInstancesNext() {

        if (this.triggerInstall) {

            this.$timeout(() => {

                this.$scope.isStep3Finished = true;

            }, 0);

        }
        this.triggerInstall = true;

    }
    // add event to the obj param
    addEvent(obj, evt, fn) {

        if (obj.addEventListener) {

            obj.addEventListener(evt, fn, false);

        } else if (obj.attachEvent) {

            obj.attachEvent(`on ${evt}`, fn);

        }

    }


    // find and return license from /licenses
    getLicense() {

        let licenseData;
        const licenseResourceId = this.$state.params.resourceId;

        // try to get license from license id or activation code from URL resourceId param
        licenseData = this.LicensesRepository.getLicenseBy(licenseResourceId) ||
                      this.LicensesRepository.getLicenseById(licenseResourceId);

        // try to get license from LicenseRepository based of app id (case for bundle)
        if (!licenseData) {

            licenseData = this.LicensesRepository.getLicenseByAppId(this.$scope.inputData.appId);

        }

        // license not found, try to find license based on component
        if (typeof licenseData === 'undefined') {

            const allLicenses = this.LicensesRepository.getAll();

            /**
             * Search each appid of each license in appIntegrationRepository
             */
            allLicenses.forEach((license) => {

                // bundle id of each license
                const licenseBundleId = license.relationships.app.data.id;

                // get app integration for the bundle id of license
                const appIntegration = AppIntegrationsRepository.getById(licenseBundleId);

                // stop at first find
                if (!licenseData && this.Util.deepFind(appIntegration, 'relationships.apps')) {

                    // search component to be deployed (from URL) in components of the bundle
                    appIntegration.relationships.apps.data.find((app) => {

                        // component found === license found
                        if (app.id === this.$scope.inputData.appId) {

                            licenseData = license;

                            return true;

                        }
                        return false;

                    });

                }

            });

        }

        return licenseData;

    }

    deployViaEmail() {

        this.deployChoose.waitingResponse = true;

        Mixpanel.send(
            'ConnectWeb Deployment Email Click',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'New User': false,
                'Product ID': this.$scope.inputData.appId,
                'Device Os': window.deviceOs,
                Page: this.getPageName(),
            },
        );

        const deploymentPayload = {
            appId: this.$scope.inputData.appId,
            license_type: (this.licenseId !== '') ? 'paid' : 'free',
            download_source: (this.licenseId !== '') ? 'wdp' : 'wdf',
            licenseId: this.licenseId,
            beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
            os: this.$scope.inputData.os,
            meta: {
                send_email: true,
                email: this.user.attributes.email,
            },
        };

        this.DeploymentUrlsRestService.deploy(deploymentPayload).then(() => {

            // success handler

            this.deployChoose.waitingResponse = false;
            this.$scope.inputData = { emails: [this.user.attributes.email] };
            this.$scope.showSuccessScreen()('email', 'pc', {});

        }, () => {

            // error handler
            this.deployChoose.waitingResponse = false;
            Alert.error({
                message: 'cw.modal.server-error.desc',
                icon: {
                    cssClasses: 'icon-pc',
                },
            });
            this.Util.closeModal();

        });

    }

    deployViaDownload() {

        Mixpanel.send(
            'ConnectWeb Deployment Download Click',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'Product ID': this.$scope.inputData.appId,
                'Device Os': window.deviceOs,
                Page: this.getPageName(),
            },
        );

        this.deployChoose.waitingResponse = true;

        const deploymentPayload = {
            appId: this.$scope.inputData.appId,
            license_type: (this.licenseId !== '') ? 'paid' : 'free',
            download_source: (this.licenseId !== '') ? 'wdp' : 'wdf',
            license_number: this.licenseId,
            beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
            os: this.$scope.inputData.os,
        };

        this.DeploymentUrlsRestService.deploy(deploymentPayload).then((response) => {

            // success handler

            this.deployChoose.waitingResponse = false;
            const downloadUrl = this.Util.deepFind(response, 'data.data.attributes.download_url');

            if (downloadUrl) {

                if (!this.initialautoInstallValue) {

                    this.$scope.showSuccessScreen()('download', 'pc', {});

                }

                this.$window.location.href = downloadUrl;

                const timeTooltip = this.$timeout(() => {

                    eventManager.broadcast('download-tooltip:show');
                    this.$timeout.cancel(timeTooltip);

                }, 2500);

                this.$rootScope.showPendingInstallCard = true;

            } else {

                Alert.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc',
                    },
                });
                this.Util.closeModal();

            }

        }, () => {

            // error handler


            Alert.error({
                message: 'cw.modal.server-error.desc',
                icon: {
                    cssClasses: 'icon-pc',
                },
            });
            this.Util.closeModal();

        });

    }

    deployOnAnotherDevice() {

        let stateName = this.$state.current.name;

        if (stateName.indexOf('.deploy') === -1) {

            stateName += '.deploy';

        }

        let stateParams = angular.extend({ ltb: 'deploy' }, this.$stateParams);

        // if we're on the subscriptions page we always install on a new device
        // to simplify the flow
        if (stateName.indexOf('subscriptions') !== -1 ||
            stateName.indexOf('store') !== -1 ||
            stateName.indexOf('home') !== -1) {

            stateParams = angular.extend(stateParams, { deviceId: 'new', appId: this.$scope.inputData.appId });

        }

        let page = 'None';

        if (stateName.indexOf('.products') !== -1) {

            page = 'Products';

        } else if (stateName.indexOf('.subscriptions') !== -1) {

            page = 'Subscriptions';

        } else if (stateName.indexOf('.store') !== -1) {

            page = 'Store';

        } else if (stateName.indexOf('.home') !== -1) {

            page = 'Homepage';

        }

        Mixpanel.send(
            'ConnectWeb Install Click',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product ID': this.app.id,
                Page: page,
                Label: 'Other Device',
            },
        );

        this.$scope.changeWizard()(stateName, stateParams, {
            reload: false,
        });

    }

}

class PcDeploymentWizardDirective {

    constructor() {

        this.template = require('./pc-deployment-wizard.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            DeploymentUrlsRestService, $stateParams,
            $window, $location, $state, $scope,
            $timeout, Util,
            $rootScope,
        ) =>
            new PcDeploymentWizardController(
                DeploymentUrlsRestService, $stateParams,
                $window, $location, $state, $scope,
                $timeout, Util,
                $rootScope,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'pcDeploymentWizardCtrl';

    }

}

_directiveDependencies.push(() =>
    new PcDeploymentWizardDirective());

angular.module('directives')
    .directive('pcDeploymentWizard', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/pc-deployment-wizard/pc-deployment-wizard.js